import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import BackLink from '../../../../common/back-link';
import PageTitle from '../../../../common/page-title';
import { getDamagedBarcodeSubmissions, getDamagedBarcodeSubmissionsCsv } from '../../../../../actions/scans';
import DamagedBarcodeSubmissionsTable from './damaged-barcode-submissions-table';
import DamagedBarcodeSubmissionsSearch from './damaged-barcode-submissions-search';

class DamagedBarcodeSubmissionsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      status: '',
      scanDateFrom: '',
      scanDateTo: '',
      page: 1
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getDamagedBarcodeSubmissions(''));
  }

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      searchValue,
      status,
      scanDateFrom,
      scanDateTo,
      page
    } = this.state;

    dispatch(getDamagedBarcodeSubmissions(searchValue, status, scanDateFrom, scanDateTo, page));
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  handleScanDateFromChange = (value) => {
    this.setState({ scanDateFrom: value.format('DD/MM/YYYY') });
  };

  handleScanDateToChange = (value) => {
    this.setState({ scanDateTo: value.format('DD/MM/YYYY') });
  };

  handleClear = () => {
    this.setState({
      searchValue: '',
      status: '',
      scanDateFrom: '',
      scanDateTo: '',
    }, this.handleSearch);
  };

  handleInputChange = (event) => {
    this.setState({ searchValue: event.target.value });
  };

  handleCsvDownload = () => {
    const {
      searchValue,
      scanDateFrom,
      scanDateTo,
      status
    } = this.state;

    getDamagedBarcodeSubmissionsCsv(searchValue, scanDateFrom, scanDateTo, status);
  };

  render() {
    const {
      loading,
      scannerCodes,
      meta,
      paging
    } = this.props;
    const {
      searchValue,
      status,
      scanDateFrom,
      scanDateTo,
      page
    } = this.state;

    return (
      <div className="container-fluid">
        <Row>
          <Col>
            <BackLink href="/admin/scans" />
          </Col>
          <PageTitle>Damaged Barcode Submissions</PageTitle>
          <DamagedBarcodeSubmissionsSearch
            searchValue={searchValue}
            status={status}
            scanDateFrom={scanDateFrom}
            scanDateTo={scanDateTo}
            statuses={meta['override-request-statuses']}
            onSearch={this.handleSearch}
            onClear={this.handleClear}
            onInputChange={this.handleInputChange}
            onStatusChange={this.handleStatusChange}
            onScanDateFromChange={this.handleScanDateFromChange}
            onScanDateToChange={this.handleScanDateToChange}
            onCsvDownload={this.handleCsvDownload}
          />
          {loading ? 'Loading...' : (
            <DamagedBarcodeSubmissionsTable
              scannerCodes={scannerCodes}
              paging={paging}
              page={page}
              handlePageChange={this.handlePageChange}
            />
)}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: !state.scans.fetched && state.scans.fetching,
  scannerCodes: state.scans.scans,
  meta: state.scans.meta,
  paging: state.scans.paging,
});

export default connect(mapStateToProps)(DamagedBarcodeSubmissionsPage);
